import { Skeleton } from '@/components/ui/skeleton';
import { EventCardSkeleton } from '@/components/events/EventCardSkeleton';

/**
 * Skeleton loading state for the upcoming events carousel.
 * Shows the title and 3 skeleton event cards in a carousel-like layout.
 */
export function UpcomingEventsCarouselSkeleton() {
  return (
    <div className="mb-6">
      <Skeleton className="h-6 w-40 mb-3" />
      <div className="flex gap-2 overflow-hidden">
        {[1, 2, 3].map((index) => (
          <div key={index} className="flex-shrink-0 w-[85%]">
            <EventCardSkeleton />
          </div>
        ))}
      </div>
      <div className="flex justify-center mt-4">
        <Skeleton className="h-4 w-24" />
      </div>
    </div>
  );
}
